var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.31 77.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.59,
    y: 0,
    width: 8.14,
    height: 77.31,
    rx: 4.07,
    ry: 4.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 34.58,
    width: 77.31,
    height: 8.14,
    rx: 4.07,
    ry: 4.07
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/white-cross.f4cbe50042a1a90ce39900c0365b0869.svg";
export { ForwardRef as ReactComponent };